import { HubConnection } from "@microsoft/signalr";
import { SignalRConnectionManager } from "./SignalRConnectionManager";

const connectionManagers = new WeakMap<HubConnection, SignalRConnectionManager>();

export function getOrCreateManager(connection: HubConnection): SignalRConnectionManager {
    let manager = connectionManagers.get(connection);
    if (!manager) {
        manager = new SignalRConnectionManager(connection);
        connectionManagers.set(connection, manager);
    }
    return manager;
}